const Images = {
    logoWhiteBgEconomics2: require('./mapfre-economics-white-bg.jpg'),
    logoWhiteBgEconomics: require('./mapfre-economics-logo.png'),
    r: require('./R-ranking.svg'),
    eLogo: require('./mapfre-economics-e-logo.svg'),
    rankingsTitle: require('./ranking de grupos aseguradores.svg'),
    rankingsTitleEnglish: require('./ranking de grupos aseguradores_en.svg'),
    expand: require('./ic_expand.png'),
    pdf_download: require('./pdf_download.png'),
    pdf_download_black: require('./pdf_download_black.png'),
    groupIcons: {
      'aegon': require('./groupLogos/aegon.svg'),
      'allianz': require('./groupLogos/allianz.svg'),
      'aviva': require('./groupLogos/aviva.svg'),
      'axa': require('./groupLogos/axa.svg'),
      'banamex': require('./groupLogos/banamex.svg'),
      'banorte': require('./groupLogos/banorte.svg'),
      'bbva': require('./groupLogos/bbva.svg'),
      'bnp paribas cardif': require('./groupLogos/bnp paribas.svg'),
      'bnp paribas cardif2': require('./groupLogos/bnp paribas.svg'),
      'bradesco': require('./groupLogos/bradesco.svg'),
      'brasilprev': require('./groupLogos/brasilprev.svg'),
      'brasilprev 1': require('./groupLogos/brasilprev.svg'),
      'crédit agricole assurance': require('./groupLogos/caf.svg'),
      'crédit agricole assurance1': require('./groupLogos/caf.svg'),
      'chubb': require('./groupLogos/chubb.svg'),
      'cnp': require('./groupLogos/cnp.svg'),
      'cnp assurances': require('./groupLogos/cnp.svg'),
      'ergo': require('./groupLogos/ergo.svg'),
      'ergo1': require('./groupLogos/ergo.svg'),
      'generali': require('./groupLogos/generalli.svg'),
      'groupama': require('./groupLogos/groupama.svg'),
      'grupo nacional provincial': require('./groupLogos/grupo nacional provincial.svg'),
      'grupo sura': require('./groupLogos/grupo sura.svg'),
      'grupo sura 2': require('./groupLogos/grupo sura.svg'),
      'grupo sura 3': require('./groupLogos/grupo sura.svg'),
      'innovacare': require('./groupLogos/innovacare.svg'),
      'itaú': require('./groupLogos/itau.svg'),
      'mapfre': require('./groupLogos/mapfre.svg'),
      'metlife': require('./groupLogos/metlife.svg'),
      'metlife inc.': require('./groupLogos/metlife.svg'),
      'poste vita': require('./groupLogos/postevita.svg'),
      'porto seguro': require('./groupLogos/portoseguro.svg'),
      'prudential': require('./groupLogos/prudential.svg'),
      'rsa': require('./groupLogos/rsa.svg'),
      'r+v': require('./groupLogos/r+v.svg'),
      'sogecap': require('./groupLogos/sogecap.svg'),
      'sogecap1': require('./groupLogos/sogecap.svg'),
      'sogecap3': require('./groupLogos/sogecap.svg'),
      'talanx': require('./groupLogos/talanx.svg'),
      'triple-s': require('./groupLogos/triple-s.svg'),
      'zurich': require('./groupLogos/zurich.svg')
    },
    backgroundTabs: {
      Tab1: require('./backgroundTabs/bckg1red.png'),
      Tab2: require('./backgroundTabs/bckg2.png'),
      Tab3: require('./backgroundTabs/bckg3.png'),
      Tab4: require('./backgroundTabs/bckg4.png'),
      Tab5: require('./backgroundTabs/bckg5.png'),
    }

};

export default Images;
